/**
 * Coin-based rank thresholds (specs/coin-based-ranks §AC-9).
 *
 * A user's RANK (1..10, Rookie → Icon) is the highest rank whose peak-coin entry threshold
 * their all-time-high coin balance meets or exceeds. Rank is a high-water mark: only up.
 *
 * MUST stay in parity with the server mirror `server/src/constants/rankThresholds.constants.js`
 * (`RANK_COIN_ENTRY`). Rank names/badges live in `ranks.constants.ts`; index maps to those.
 */

/** Peak-coin balance required to ENTER each rank; index = rank - 1 (rank 1 = 0 coins). */
export const RANK_COIN_ENTRY: readonly number[] = [
  0, // 1 Rookie
  2_500, // 2 Prospect
  5_000, // 3 Contender
  10_000, // 4 Challenger
  20_000, // 5 Veteran
  40_000, // 6 All-Star
  75_000, // 7 Champion
  150_000, // 8 Superstar
  300_000, // 9 Legend
  600_000, // 10 Icon
];
